import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

import { environment } from '../http/environment';

@Component({
   selector: 'app-template',
   template: `<div>{{message}}</div>
      <form ngNoForm method="post" id="form" [action]="url" *ngIf="params">
         <ng-container *ngFor="let key of params.keys">
            <input type="hidden" [name]="key" [value]="params.get(key)" />
         </ng-container>
      </form>`,
})
export class TemplateComponent implements OnInit {

   url = environment.cybersourceUrl;
   params: ParamMap;
   message = 'Please wait while you are redirected...';

   constructor(
      private route: ActivatedRoute,
   ) { }

   ngOnInit() {
      history.replaceState( {}, '', '/' );

      this.route.paramMap.subscribe(( params: ParamMap ) => {
         this.params = params;

         if ( params ) {
            setTimeout( () => {
               ( document.getElementById( 'form' ) as HTMLFormElement ).submit();
            }, 100 );
         } else {
            this.message = 'Unable to process your request at this time';
            // setTimeout(() => window.history.back(), 2000 );
         }
      });
   }
}
